import { Directive, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';
import { ConfigService, injectCurrentUser } from '@assist/shared/data';
import { CalendarsService } from '@cue/calendars';

@Directive({
  selector: '[calendarsViewEnabled], [*calendarsViewEnabled]',
  standalone: true,
})
export class CalendarsViewEnabledDirective implements OnInit {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private configService = inject(ConfigService);
  private calendarsService = inject(CalendarsService);
  private currentUser = injectCurrentUser();
  ngOnInit() {
    const user = this.currentUser()?.data;

    if (!user || !this.calendarsService.supportsCalendarSyncView()) {
      this.viewContainer.clear();
      return;
    }

    if (this.configService.value.enableReservations && user.features.assistCalendarsView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
